import React from 'react';
import { Container } from './ui/Container';
export function WhoItsFor() {
  const audiences = [{
    title: 'Schools & Administrators',
    description: 'Enhance family engagement strategies and build stronger bridges between home and school environments through structured, meaningful programming.'
  }, {
    title: 'Educators',
    description: 'Support the whole child by acknowledging and strengthening the critical support systems at home.'
  }, {
    title: 'Community Organizations',
    description: 'Partner with us to support fatherhood initiatives in our community.'
  }, {
    title: 'Families',
    description: 'Experience a program that honors your journey and provides a quiet space to celebrate the bond between fathers and children.'
  }];
  return <section id="who-its-for" className="py-20 bg-[#FAFAF8] border-y border-[#E5E5E0]" data-id="element-134">
      <Container data-id="element-135">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-136">
          <div className="relative" data-id="element-137">
            <h2 className="text-4xl font-serif text-[#2D2D2D] mb-8" data-id="element-138">
              Who We Serve
            </h2>
            <div className="relative inline-block" data-id="element-139">
              {/* Decorative elements */}
              <svg className="absolute -top-4 -left-4 w-12 h-12 text-[#3D5A4C] opacity-60" viewBox="0 0 100 100" fill="none" data-id="element-140">
                <path d="M20 50 L35 50 M50 20 L50 35" stroke="currentColor" strokeWidth="4" strokeLinecap="round" data-id="element-141" />
              </svg>
              <svg className="absolute -bottom-6 -right-6 w-16 h-16 text-[#3D5A4C] opacity-60" viewBox="0 0 100 100" fill="none" data-id="element-142">
                <circle cx="50" cy="50" r="8" fill="currentColor" data-id="element-143" />
                <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="3" data-id="element-144" />
              </svg>
              <svg className="absolute top-1/2 -right-8 w-10 h-10 text-[#3D5A4C] opacity-40" viewBox="0 0 100 100" fill="none" data-id="element-145">
                <path d="M50 20 L60 40 L80 50 L60 60 L50 80 L40 60 L20 50 L40 40 Z" fill="currentColor" data-id="element-146" />
              </svg>

              {/* Circular image with border */}
              <div className="relative w-full max-w-md" data-id="element-147">
                <div className="aspect-square rounded-full overflow-hidden border-4 border-[#3D5A4C] shadow-lg" data-id="element-148">
                  <img src="https://cdn.magicpatterns.com/uploads/pi8FPyE5R5ArJGqXqCojSD/498548559_9527481284030869_1764752632538562266_n.jpg" alt="Father and child sharing a joyful moment" className="w-full h-full object-cover" data-id="element-149" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center" data-id="element-150">
            <div className="space-y-10" data-id="element-151">
              {audiences.map(item => <div key={item.title} className="border-l-2 border-[#3D5A4C] pl-6" data-id="element-152">
                  <h3 className="text-2xl font-serif text-[#2D2D2D] mb-2" data-id="element-153">
                    {item.title}
                  </h3>
                  <p className="text-[#555555] leading-relaxed" data-id="element-154">
                    {item.description}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </Container>
    </section>;
}